import { useEffect } from "react";
import { getFieldValues } from "../utils/getFieldValuesFromMetadata";

const useFieldValuesEffect = ({ selectedFieldName, metaData, setFieldValues, selectedFieldValue, setSelectedFieldValue }) => {
    useEffect(() => {
        const data = getFieldValues(selectedFieldName, metaData);
        setFieldValues(data);

        const filteredSelectedValues = selectedFieldValue?.filter(
            (selectedValue) =>
                data.some((dataItem) => dataItem.value === selectedValue),
        );
        if (filteredSelectedValues?.length !== selectedFieldValue?.length) {
            setSelectedFieldValue(filteredSelectedValues);
        }
    }, [selectedFieldName, selectedFieldValue, metaData, setFieldValues, setSelectedFieldValue]);
};

export default useFieldValuesEffect;
